import React from 'react';

export const TransportationFormSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#F5F8F9] pb-24">
      <div className="max-w-[1000px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Header */}
        <div className="flex flex-row justify-start items-center mb-8 gap-4">
          <div className="p-1.5 sm:p-2 bg-gray-200 rounded-xl w-8 h-8 animate-pulse"></div>
          <div className="h-8 w-64 bg-gray-200 rounded-md animate-pulse"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-[#E4E8EA] p-4 sm:p-6 lg:p-8">
          {/* Profile Image Upload */}
          <div className="mb-8">
            <div className="h-5 w-32 bg-gray-200 rounded-md animate-pulse mb-4"></div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              <div className="w-24 h-24 sm:w-32 sm:h-32 bg-gray-200 rounded-xl animate-pulse"></div>
              <div className="h-4 w-64 bg-gray-200 rounded-md animate-pulse"></div>
            </div>
          </div>

          <div className="space-y-6">
            {/* Name Fields - 3 columns */}
            <div className="flex flex-col md:flex-row gap-6">
              <div>
                <div className="h-5 w-24 bg-gray-200 rounded-md animate-pulse mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
              </div>
              <div>
                <div className="h-5 w-28 bg-gray-200 rounded-md animate-pulse mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
              </div>
              <div>
                <div className="h-5 w-24 bg-gray-200 rounded-md animate-pulse mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
              </div>
            </div>

            {/* Employee ID */}
            <div>
              <div className="h-5 w-28 bg-gray-200 rounded-md animate-pulse mb-2"></div>
              <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
            </div>

            {/* Designation and Third Party Status */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <div className="h-5 w-32 bg-gray-200 rounded-md animate-pulse mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
              </div>
              <div>
                <div className="h-5 w-36 bg-gray-200 rounded-md animate-pulse mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
              </div>
            </div>

            {/* Email */}
            <div>
              <div className="h-5 w-20 bg-gray-200 rounded-md animate-pulse mb-2"></div>
              <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
            </div>

            {/* Contact */}
            <div>
              <div className="h-5 w-32 bg-gray-200 rounded-md animate-pulse mb-2"></div>
              <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
            </div>

            {/* Joining Date */}
            <div>
              <div className="h-5 w-28 bg-gray-200 rounded-md animate-pulse mb-2"></div>
              <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
            </div>

            {/* Emergency Contact Fields */}
            <div className="space-y-4">
              <div>
                <div className="h-5 w-40 bg-gray-200 rounded-md animate-pulse mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
              </div>
              <div>
                <div className="h-5 w-44 bg-gray-200 rounded-md animate-pulse mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
              </div>
              <div>
                <div className="h-5 w-48 bg-gray-200 rounded-md animate-pulse mb-2"></div>
                <div className="h-10 w-full bg-gray-200 rounded-md animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
